import { render, staticRenderFns } from "./LiveStageNG.vue?vue&type=template&id=41ad9541&scoped=true"
import script from "./LiveStageNG.vue?vue&type=script&lang=js"
export * from "./LiveStageNG.vue?vue&type=script&lang=js"
import style0 from "./LiveStageNG.vue?vue&type=style&index=0&id=41ad9541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad9541",
  null
  
)

export default component.exports